import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'

const StatsService = {}

StatsService.getVpsReport = () =>
  fetch({
    url: `${env.VPS_ENDPOINT_URL}/api/vps/report`,
    method: 'GET',
  })

export default StatsService
